import { z } from 'zod';
import i18n from '@/shared/i18n/i18n';

const loginSchema = z.object({
  email: z
    .string()
    .nonempty(i18n.t('login.errors.email'))
    .email(i18n.t('login.errors.emailFormat')),
  password: z.string().nonempty(i18n.t('login.errors.password')),
});

const otpSchema = z.object({
  otp: z.string().length(6, i18n.t('login.errors.otp')),
});

type LoginFormValues = z.infer<typeof loginSchema>;

type OtpFormValues = z.infer<typeof otpSchema>;

export { loginSchema, otpSchema, type LoginFormValues, type OtpFormValues };
